module.exports = __webpack_public_path__ + "img/show-img3.2f91ae6d.png";